import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'

import styles from './input_error.less'

const errorsShape = PropTypes.oneOfType([PropTypes.array, PropTypes.string])

class InputError extends React.Component {
  /*
		showAsError determines whether we're displaying the error with a red border
		and a red background.
		when it's true, the errors displayed are the ones in the 'errors' prop (if blank, nothing is rendered).
		when it's false, the errors displayed are the ones in the 'nonErrors' props (if blank, nothing is rendered).
	*/
  static propTypes = {
    showAsError: PropTypes.bool,
    errors: errorsShape,
    nonErrors: errorsShape,
    align: PropTypes.oneOf(['left', 'center']),
  }

  static defaultProps = {
    errors: null,
    align: 'left',
    showAsError: true,
  }

  render() {
    let errors
    if (!this.props.showAsError) {
      errors = this.props.nonErrors
    } else {
      errors = this.props.errors
    }

    if (!errors) {
      return null
    }

    if (!Array.isArray(errors)) {
      errors = [errors]
    }
    let styleNames = ['error']
    if (this.props.align === 'center') {
      styleNames.push('centered')
    }
    if (this.props.showAsError) {
      styleNames.push('red')
    }

    return (
      <div styleName={styleNames.join(' ')}>
        {errors.length > 1 && (
          <ul>
            {errors.map((e, i) => (
              <li key={i}>
                <span>{e}</span>
              </li>
            ))}
          </ul>
        )}
        {errors.length === 1 && errors[0]}
      </div>
    )
  }
}

export default cssModules(InputError, styles, { allowMultiple: true })
